import type { MPAInterceptedResponse } from '@repo/api-gw-sdk';

export const isMPAInterceptedResponse = (
  body: unknown
): body is MPAInterceptedResponse => {
  if (!body || typeof body !== 'object') return false;
  const candidate = body as Record<string, unknown>;
  return (
    typeof candidate.mpaRequest === 'object' &&
    candidate.mpaRequest !== null &&
    typeof candidate.mpaPolicies === 'object' &&
    candidate.mpaPolicies !== null
  );
};

export class MpaCancelledError extends Error {
  constructor() {
    super('Operation cancelled by user');
    Object.setPrototypeOf(this, MpaCancelledError.prototype);
    this.name = 'MpaCancelledError';
  }
}
